import { Link } from 'react-router-dom';
import { hotItems } from '@/mocks/home';

export default function HotItems() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10 md:mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">精选当月最受关注的番号作品</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {hotItems.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-semibold">
                    {item.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <span className="text-background-50 text-xs font-mono font-semibold tracking-wider">{item.code}</span>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-800 leading-snug line-clamp-2 mb-1.5 group-hover:text-primary-700 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{item.actress}</span>
                  <span>{item.label}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}